import { CONTACT_INFO, PARTNER_COUNTS } from '@/helpers/constants'

/**
 * Every image extracted from the company profile sits flat in /src/assets.
 * Names are resolved at runtime (partner-medical-01.webp, value-03.webp …),
 * so a require.context gives us the hashed, bundled URL by file name.
 */
const assetContext = require.context('../assets', false, /\.(webp|png|svg)$/)

const assetRegistry = assetContext.keys().reduce((registry, key) => {
	registry[key.replace(/^\.\//, '')] = assetContext(key)
	return registry
}, {})

/** Resolve a bundled asset URL by file name. */
export function assetUrl(name) {
	if (!name) return ''
	const url = assetRegistry[name]
	if (!url && process.env.NODE_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.warn(`[beetronix] missing asset: ${name}`)
	}
	return url || ''
}

const padded = (index) => String(index + 1).padStart(2, '0')

/** Module icon of one ERP module, by sector and module index. */
export function moduleIconUrl(sectorKey, index) {
	return assetUrl(`mod-${sectorKey}-${padded(index)}.webp`)
}

/** Circular service badge, by service index. */
export function serviceIconUrl(index) {
	return assetUrl(`service-${padded(index)}.webp`)
}

/** Hexagon value icon, by value index. */
export function valueIconUrl(index) {
	return assetUrl(`value-${padded(index)}.webp`)
}

/** All partner logo URLs of one sector, in profile order. */
export function partnerLogoUrls(sectorKey) {
	return Array.from(
		{ length: PARTNER_COUNTS[sectorKey] || 0 },
		(unused, index) => assetUrl(`partner-${sectorKey}-${padded(index)}.webp`)
	)
}

/**
 * A vCard blob URL, so a visitor arriving from the QR code on the business
 * card can save the company contact in one tap.
 */
export function createVCardUrl() {
	const card = [
		'BEGIN:VCARD',
		'VERSION:3.0',
		'N:;Beetronix;;;',
		'FN:Beetronix',
		'ORG:Beetronix',
		'TITLE:Empower Every Process',
		`TEL;TYPE=WORK,VOICE:${CONTACT_INFO.phone}`,
		`EMAIL;TYPE=WORK:${CONTACT_INFO.email}`,
		`URL:${CONTACT_INFO.websiteUrl}`,
		'ADR;TYPE=WORK:;;Al-Mohafaza, next to Franciscan school;Aleppo;;;Syria',
		'END:VCARD'
	].join('\r\n')

	return URL.createObjectURL(new Blob([card], { type: 'text/vcard;charset=utf-8' }))
}

/** True when the visitor asked the OS to reduce motion. */
export function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
